import { render, staticRenderFns } from "./ComponenteIncisione.vue?vue&type=template&id=6776b38e&"
import script from "./ComponenteIncisione.vue?vue&type=script&lang=ts&"
export * from "./ComponenteIncisione.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteIncisione.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports